<template>
  <div class="allFund">
    <div class="contentWrap1">
      <div class="topText">用户总资金结构图</div>
      <TreeChart :tree-data="fundData" />
    </div>
  </div>
</template>
<script>
/*global http protocolTrans util*/
import TreeChart from './fundAllTree.vue'

export default {
  components: {
    TreeChart
  },
  data() {
    return {
      firmIds: [],
      fundData: {}
    }
  },
  mounted() {
    this.getAllFirmId()
  },
  methods: {
    getAllFirmId() {
      let fundData = {
        accountName: '总资金',
        num: 0,
        color: '#333333',
        extend: true,
        children: []
      }
      const allFirmId = JSON.parse(localStorage.getItem('FirmIdList_w'))
      const marketList = window.g.APP_market
      allFirmId.forEach(val => {
        // 市场列表追加子数据
        marketList.forEach(item => {
          if (val.marketId == item.marketId) {
            fundData.children.push({
              accountName: item.accountName,
              marketId: item.marketId,
              num: 0,
              color: '#333333',
              extend: true,
              children: [{
                accountName: '可用资金',
                color: '#333333',
                extend: true,
                num: 0
              },
              {
                accountName: '冻结资金',
                color: '#333333',
                extend: true,
                num: 0
              }]
            })
            this.firmIds.push(val.firmId)
          }
        })
      })
      this.getAllFund(fundData)
    },
    // 查询所有市场的资金情况
    getAllFund(fundData) {
      protocolTrans.param_mineAsset.param.firmIds = this.firmIds
      http.postFront(protocolTrans.param_mineAsset).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            const dataList = response.data.value
            fundData.num = 0
            const _this = this
            dataList.forEach(item => {
              fundData.children.forEach((val, index) => {
                if (Number(item.marketId) === Number(val.marketId)) {
                  if (item.marketId == 28 && val.marketId == 28) {
                    if (Number(item.floatPl) < 0) {
                      val.children[0].num = util.floatAdd(util.floatSub(item.balance, item.frozenFunds), item.floatPl)
                    } else {
                      val.children[0].num = util.floatSub(item.balance, item.frozenFunds)
                    }
                  } else {
                    val.children[0].num = util.floatSub(item.balance, item.frozenFunds)
                  }
                  val.children[1].num = item.frozenFunds
                  val.num = item.balance
                  fundData.num = util.floatAdd(val.num, fundData.num)
                }
              })
            })
            _this.fundData = fundData
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.allFund {
  position: relative;
  height: 800px;
  background: #ffffff !important;
  //   top: 100px;
  .divSize {
    width: 192px;
    height: 86px;
    text-align: center;
    background-color: #333;
    font-size: 20px;
    .title {
      font-weight: 400;
      padding-top: 14px;
      color: rgba(255, 255, 255, 0.8);
    }
    .text1 {
      font-weight: 600;
      color: #ffffff;
    }
  }
  .rColor {
    background: #ef5557;
  }
  .gColor {
    background: #24df11;
  }
  .bColor {
    background: #1c7df6;
  }
  .yColor {
    background: #ff9705;
  }
  .contentWrap1 {
    // position: absolute;
    // margin-top: 100px;
    // left: 43%;
    margin: 0 auto;
    // margin-left: 800px;
    .topText {
      text-align: center;
      padding-top: 99px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
    }
    .fund {
      position: relative;
      margin-bottom: 530px;
      .line {
        position: absolute;
        width: 2px;
        height: 160px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 86px;
        left: 96px;
      }
      .line1 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 332px;
        left: 96px;
      }
      .line111 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: -437px;
      }
      .line112 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: -217px;
      }
      .line21 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 332px;
        left: 518px;
      }
      .line11 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 332px;
        left: -328px;
      }
      .line4 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: -14px;
      }
      .line5 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: 206px;
      }
      .line3 {
        position: absolute;
        width: 220px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: -14px;
      }
      .line113 {
        position: absolute;
        width: 220px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: -437px;
      }
      .line213 {
        position: absolute;
        width: 220px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        right: -436px;
      }
      .line211 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        right: -438px;
      }
      .line212 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        right: -216px;
      }
      .line6 {
        position: absolute;
        width: 600px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 162px;
        left: -289px;
      }
      .line7 {
        position: absolute;
        width: 2px;
        height: 88px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 162px;
        left: -329px;
      }
      .zjFund {
        position: absolute;
        top: 246px;
        left: -420px;
      }
      .zjFundKy {
        position: absolute;
        top: 492px;
        left: -527px;
      }
      .zjFundDj {
        position: absolute;
        top: 492px;
        left: -317px;
      }
      .ddFund {
        position: absolute;
        top: 245px;
        left: 422px;
      }
      .ddFundKy {
        position: absolute;
        top: 492px;
        right: -320px;
      }
      .ddFundDj {
        position: absolute;
        top: 492px;
        right: -530px;
      }
      .line9 {
        position: absolute;
        width: 2px;
        height: 88px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 162px;
        left: 519px;
      }
      .line8 {
        position: absolute;
        width: 846px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 162px;
        left: -327px;
      }
      .xhFund {
        position: absolute;
        top: 246px;
      }
      .xhFundKy {
        position: absolute;
        top: 492px;
        left: -110px;
      }
      .xhFundDj {
        position: absolute;
        top: 492px;
        right: -110px;
      }
    }
  }
}
</style>
